/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

//
//
//  TODO : wczytywanie modułów do sklepu powinno być automatyczne. Wszystkie pliki w ./modules
//
//
import groups from './modules/groups.module';
import auth from './modules/auth.module';
import partners from './modules/partners.module';
import profiles from './modules/profiles.module';
import client from './modules/client.module';
import notification from './modules/notification.module';
import officials from './modules/officials.module';
import employees from './modules/employees.module';
import system from './modules/system.module';
import benefitUse from './modules/benefitUse.module';
import benefitsHistory from './modules/benefitsHistory.module';
import entityHistory from './modules/entityHistory.module';
import settings from './modules/settings.module';
import settingGroups from './modules/settingGroups.module';
import mailTemplates from './modules/mailTemplates.module';
import roles from './modules/roles.module';
import modalClose from './modules/modalClose.module';
import categories from './modules/categories.module';
import terms from './modules/terms.module';
import breadcrumbs from './modules/breadcrumbs.module';
import permissions from './modules/permissions.module';
import pages from './modules/pages.module';
import access from './modules/access.module';
import consents from './modules/consents.module';
import stats from './modules/stats.module';

Vue.use(Vuex);
// Create a new store

const store = new Vuex.Store({
  actions: {},
  getters: {},
  mutations: {},
  state: {},
  modules: {
    groups,
    auth,
    partners,
    profiles,
    client,
    notification,
    officials,
    employees,
    system,
    benefitUse,
    benefitsHistory,
    entityHistory,
    settings,
    settingGroups,
    mailTemplates,
    roles,
    modalClose,
    categories,
    terms,
    breadcrumbs,
    permissions,
    pages,
    access,
    consents,
    stats
  }
});

export default store;
